function routeStateToViewerState(state: string): string {
  return state.replace(/^\//, '');
}

export default routeStateToViewerState;
